import { render } from "./EditProfileHobbies.vue?vue&type=template&id=1aa0e73e"
import script from "./EditProfileHobbies.vue?vue&type=script&lang=js"
export * from "./EditProfileHobbies.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__